import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {t} from "../common/i18n.js";
import {formatLocalDate, withAttrs} from "../common/utils.js";
import Collapsible from "./collapsible.js";
import {Calendar, InfoSmall} from "./icons.js";
import Stack from "./stack.js";
import {colors, fontFamily, lineHeight} from "./theme.js";
export default function ProductVariant(props) {
  const {article, variant, selected, readOnly, ...rest} = props;
  if (!variant)
    return null;
  const {cf_shop_print_inside, cf_shop_print_outside} = article;
  const {icon, name, features = []} = variant;
  const hasIcon = !!icon && !!icon.filename;
  const showUploadDate = (cf_shop_print_inside !== "0" || cf_shop_print_outside !== "0") && article.cf_last_possible_upload_date;
  const showFeatures = !readOnly && (features.length || showUploadDate || article.plannedDeliveryDate);
  return /* @__PURE__ */ React.createElement(Container, {
    selected,
    readOnly,
    ...rest
  }, /* @__PURE__ */ React.createElement(Title, {
    withIcon: hasIcon
  }, icon && /* @__PURE__ */ React.createElement(Icon, {
    asset: icon
  }), name), showFeatures && /* @__PURE__ */ React.createElement(Collapsible, {
    collapsed: !selected
  }, /* @__PURE__ */ React.createElement(FeaturesContainer, null, /* @__PURE__ */ React.createElement(DeliveryDate, {
    article
  }), showUploadDate && /* @__PURE__ */ React.createElement(LastPossibleUploadDate, {
    article
  }), features.map((f) => /* @__PURE__ */ React.createElement(Feature, {
    key: f._uid,
    ...f
  })))));
}
function LastPossibleUploadDate(props) {
  const {cf_last_possible_upload_date} = props.article;
  if (!cf_last_possible_upload_date)
    return null;
  const formattedDate = formatLocalDate(cf_last_possible_upload_date);
  return /* @__PURE__ */ React.createElement(DateContainer, null, /* @__PURE__ */ React.createElement(InfoSmall, null), t("Upload der Druckdaten bis"), " ", /* @__PURE__ */ React.createElement("strong", null, formattedDate));
}
function DeliveryDate(props) {
  const {plannedDeliveryDate} = props.article;
  if (!plannedDeliveryDate)
    return null;
  const formattedDeliveryDate = formatLocalDate(plannedDeliveryDate);
  return /* @__PURE__ */ React.createElement(DateContainer, null, /* @__PURE__ */ React.createElement(Calendar, null), t("Liefertermin"), " ", /* @__PURE__ */ React.createElement("strong", null, formattedDeliveryDate));
}
function Feature(props) {
  const {icon, text} = props;
  return /* @__PURE__ */ React.createElement(FeatureContainer, null, /* @__PURE__ */ React.createElement(Icon, {
    asset: icon
  }), text);
}
function Icon(props) {
  const {asset} = props;
  if (!asset)
    return null;
  if (!asset.filename)
    return null;
  return /* @__PURE__ */ React.createElement(IconContainer, {
    src: asset.filename,
    loading: "lazy"
  });
}
const Container = styled.div`
  background: white;
  border: 1px solid ${colors.b5};
  border-radius: 4px;
  padding: 16px;

  ${({readOnly}) => readOnly && `
      border: 0 none;
      padding: 8px 0;
  `}

  ${({selected}) => selected && `
      background: ${colors.c3};
      border-color: ${colors.c1};
    `}
`;
const FeaturesContainer = styled(withAttrs(Stack, {spacing: "xs"}))`
  margin-top: 8px;
`;
const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};

  img,
  svg {
    flex-shrink: 0;
    // width: 16px;
    // height: 16px;
    position: relative;
    margin-right: 6px;
    align-self: flex-start;
    top: calc(${lineHeight} / 2);
    transform: translateY(-50%);
    object-fit: contain;
  }
`;
const IconContainer = styled.img`
  display: block;
  object-fit: contain;
`;
const Title = styled(FeatureContainer)`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 14px;
  line-height: ${lineHeight};

  ${({withIcon}) => withIcon && `
    margin-right: 6px;
  `}
`;
const DateContainer = styled(FeatureContainer)`
  strong {
    font-weight: bold;
    padding-left: 3px;
  }
`;
